module.exports = __webpack_public_path__ + "static/media/banana.217fd605.jpg";